import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { DashboardMaintenancesComponent } from './dashboard-maintenances.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.MAINTENANCES' };
var routes = [
    {
        path: 'relatorios/manutencoes',
        component: DashboardMaintenancesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var DashboardMaintenancesModule = /** @class */ (function () {
    function DashboardMaintenancesModule() {
    }
    return DashboardMaintenancesModule;
}());
export { DashboardMaintenancesModule };
export { ɵ0 };
